import {AfterViewInit, Component, OnInit} from '@angular/core';
import { SplitButtonElement } from '@app/components/elements/splitbutton/splitbutton.component';

const audioFrequencies = ['Hz512', 'Hz1024', 'Hz2048', 'Hz4096'] as const;
type TAudioFrequenz = typeof audioFrequencies[number]; // 'Hz512' | 'Hz1024' | 'Hz2048' | 'Hz4096';
type TAudioChannel = 'left' | 'right';

@Component({
	selector: 'app-audio-showcase',
	templateUrl: './audio-showcase.component.html',
	styleUrls: ['./../../../workflow/components/navigator/wizard-view/wizard-view.component.scss']
})
export class AudioShowcaseComponent implements  OnInit, AfterViewInit{

	public isPlaying: boolean;
	public volume = 1.0;

	private audioElementsByChannel: Record<TAudioChannel, Record<TAudioFrequenz, HTMLAudioElement>>;
	private allAudioElements: HTMLAudioElement[] = [];
	private _selectedAudio: TAudioFrequenz = 'Hz512';
	private _selectedDirection: TAudioChannel = 'left';

	public audioPlayButton: SplitButtonElement = {
		title: 'Play',
		type: 'primary',
		icon: 'play',
		callback: () => this.togglePlay(),
	};

	set selectedAudio(audio: TAudioFrequenz) {
		if (this._selectedAudio === audio) {
			return;
		}

		this._selectedAudio = audio;
		this.pauseAllMedia();
	}

	get selectedAudio(): TAudioFrequenz {
		return this._selectedAudio;
	}

	set selectedDirection(direction: TAudioChannel) {
		if (this._selectedDirection === direction) {
			return;
		}

		this._selectedDirection = direction;
		this.pauseAllMedia();
	}

	get selectedDirection(): TAudioChannel {
		return this._selectedDirection;
	}

	ngOnInit(): void {
		this.initAudioContainer();
	}

	ngAfterViewInit(): void {
		this.selectedAudio = 'Hz512';
		this.selectedDirection = 'left';
	}

	private initAudioContainer(): void {
		this.audioElementsByChannel = {left: {} as Record<TAudioFrequenz, HTMLAudioElement>, right: {} as Record<TAudioFrequenz, HTMLAudioElement>};
		for (const freq of audioFrequencies) {
			const trimmedFreq = freq?.substr(2);
			const left = new Audio(`assets/sounds/${trimmedFreq} L.mp3`);
			const right = new Audio(`assets/sounds/${trimmedFreq} R.mp3`);
			this.allAudioElements.push(left);
			this.audioElementsByChannel.left[freq] = left;
			this.audioElementsByChannel.left[freq].load();
			this.allAudioElements.push(right);
			this.audioElementsByChannel.right[freq] = right;
			this.audioElementsByChannel.right[freq].load();
		}
	}

	private pauseAllMedia(): void {
		for (const audioEl of this.allAudioElements) {
			audioEl.pause();
			audioEl.currentTime = 0;
		}
		this.isPlaying = false;

		setTimeout(() => { // prevent ngAfterViewInit-Error "Expression has been changed"
			this.audioPlayButton.title = 'Play';
			this.audioPlayButton.icon = 'play';
		}, 0);
	}

	togglePlay(): void {
		if (this.isPlaying) {
			this.getCurrentAudio().pause();
			this.getCurrentAudio().currentTime = 0;
			this.isPlaying = false;

			this.audioPlayButton.title = 'Play';
			this.audioPlayButton.icon = 'play';
		}
		else {
			this.getCurrentAudio().play().catch(console.error);
			this.isPlaying = true;

			this.audioPlayButton.title = 'Stop';
			this.audioPlayButton.icon = 'pause';
		}
	}

	getCurrentAudio(): HTMLAudioElement {
		return this.audioElementsByChannel[this._selectedDirection][this._selectedAudio];
	}

	setVolume(): void {
		for (const audioEl of this.allAudioElements) {
			audioEl.volume = this.volume;
		}
	}

}
